import * as React from 'react';
import * as S from './styles';
import * as T from './types';
import { DEFAULT_FONT_FAMILY } from 'common/constants';
import { cloneDeep } from 'lodash';
import { getRatingRecommended } from '../utils';

const DragReviews: React.FC<T.IProps> = (props) => {

    const [currentCursor, setCurrentCursor] = React.useState<string>();
    const [selected, setSelected] = React.useState<number>();
    const [currentDropArea, setCurrentDropArea] = React.useState<number>();

    const handleDragStart = (e: React.DragEvent<HTMLDivElement>, id: number) => {
        const rect = e.currentTarget.getBoundingClientRect();
        let element = e.currentTarget?.cloneNode(true) as HTMLElement;
        element.id = `${id}-shadow`;
        element.style.position = `fixed`;
        element.style.top = `-1000px`;
        element.style.height = `${rect.height}px`;
        element.style.width = `${rect.width}px`;
        element.style.fontFamily = DEFAULT_FONT_FAMILY;
        element.style.backgroundColor = `#FFFFFF`;
        document.body.appendChild(element);
        e.dataTransfer.setDragImage(element, (e.clientX - rect.x), (e.clientY - rect.y));
        e.dataTransfer.effectAllowed = "move";
        setSelected(id);
        setCurrentCursor("grabbing");
    }

    const handleDragEnd = () => {
        setCurrentCursor(undefined);
        setSelected(undefined);
        setCurrentDropArea(undefined);
    }

    const handleDragEnter = (e: React.DragEvent<HTMLDivElement>, id: number) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = "move";
        let element = e.currentTarget;
        element.classList.add("dragged-over");
        if (selected !== undefined && (id < selected || id > selected)) {
            setCurrentDropArea(id);
        }
    }

    const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = "move";
    }

    const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = "move";
        setCurrentDropArea(undefined);
    }

    const onDrop = (e: React.DragEvent<HTMLDivElement>, id: number) => {
        e.preventDefault();
        e.currentTarget.classList.remove("dragged-over");
        if (selected !== undefined && currentDropArea !== undefined) {
            let reviews = cloneDeep(props.reviews);
            reviews.splice(currentDropArea, 0, reviews[selected]);
            reviews.splice(currentDropArea < selected ? selected + 1 : selected, 1);
            props.setReviews(reviews);
        }
    };

    const renderDropArea = (id: number) => {
        return (
            <S.DropArea
                widthValue={id === currentDropArea ? `117px` : undefined}
                onDragEnter={(e) => handleDragEnter(e, id)}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={(e) => onDrop(e, id)}
            />
        );
    }

    return (
        <S.Root style={props.style} >
            <S.DragContainer>
                {
                    props.reviews.map((review, index) => {
                        return (
                            <S.Item key={index} >
                                {index !== selected && renderDropArea(index)}
                                <S.Card
                                    draggable="true"
                                    widthValue={index === selected ? '0px' : undefined}
                                    cursorValue={currentCursor}
                                    onDragStart={(e) => handleDragStart(e, index)}
                                    onDragEnd={handleDragEnd}
                                >
                                    <S.CardDetail>
                                        {review.detail}
                                    </S.CardDetail>
                                    <S.CardStars>
                                    {getRatingRecommended({
                                        provider: review.provider,
                                        recommended: review.recommended,
                                        rating: review.rating,
                                        starStyle: {
                                            width: "9px",
                                            height: "9px",
                                            margin: "2px",
                                            padding: "0px",
                                        },
                                        showEmptyStars: false,
                                        thumbtext:false,
                                        thumbsStyle: {width: "auto", height: "11"},
                                    } )}
                                    </S.CardStars>
                                </S.Card>
                                {index + 1 === props.reviews.length && renderDropArea(index + 1)}
                            </S.Item>
                        );
                    })
                }
            </S.DragContainer>
        </S.Root>
    );
}

export default DragReviews;
